import { defineMessages } from "@/i18n";
import en from "./en";

export const framesSharedMessages = defineMessages("frames-shared", en);
